import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const circleStyle = {
  color: '#ffffff'
};

export default class AppButton extends React.Component {

  state = {
  }

  _getButtonContent() {
    if(this.props.isLoading) {
      return <CircularProgress style={circleStyle} size={20} />;
    }

    return this.props.children;
  }

  render() {
    return (
      <button {...this.props}>
        {this._getButtonContent()}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/crud/AppButton.js